module.exports = __webpack_public_path__ + "img/xiaoxi_xitongtongzi_icon.23c2aab0.svg";